import O1HD from "../../../engines/gameEngine";
import Level_Charade from "./Level_Charade";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Level_Charade_selectItem extends cc.Component {

    levelScript:Level_Charade = null;
    
    currentStr:string = "";

    initStr:string = "";

    @property({type:cc.Node,displayName:"文本节点"})
    lbNode:cc.Node = null;

    setData(str:string,levelScript:Level_Charade){
        this.levelScript = levelScript;
        this.currentStr = str;
        this.initStr = str;
        this.updateLb();
    }
    
    updateLb(){
        this.lbNode.getComponent(cc.Label).string = this.currentStr;
    }

    init(){
        this.currentStr = this.initStr;
        this.updateLb();
    }

    onBtnMe(){
        O1HD.getManagers().soundMgr.playSound("mainSound/clickWord");
        O1HD.getManagers().soundMgr.playVibrate();
        if(this.currentStr!= ""){
            let isTrue:boolean = this.levelScript.addOneAnswer(this.initStr,this.node);
            if(isTrue){
                this.currentStr = "";
                this.updateLb();
            }
        }
    }

}
